import { render, staticRenderFns } from "./PurchaeRecords.vue?vue&type=template&id=3669e024&scoped=true&"
import script from "./purchaeRecords.js?vue&type=script&lang=js&"
export * from "./purchaeRecords.js?vue&type=script&lang=js&"
import style0 from "./PurchaeRecords.vue?vue&type=style&index=0&id=3669e024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3669e024",
  null
  
)

export default component.exports